(function () {
    const AlmeUiVersion = process.env.VERSION;

    // get script reference
    const scriptTags = document.getElementsByTagName('script');
    let url = '';
    for (let i = 0; i < scriptTags.length; i++) {
        const src = scriptTags[i].getAttribute('src', -1);
        // Use indexOf for IE 11 support
        // eslint-disable-next-line @typescript-eslint/prefer-includes
        if (src > '' && src.toLowerCase().indexOf('nextit-script-manager.js') > -1) {
            url = src;
            break;
        }
    }

    const baseUrl = url.substr(0, url.toLowerCase().lastIndexOf('/'));

    //  Load CSS first

    
    function appendTheChild(elementToAppend){
        const parent = document.getElementsByTagName('head')[0];
		if (parent) parent.appendChild(elementToAppend);
    }

    function  NITLoadCss() {
        const linkTag = document.createElement('link');
		linkTag.id = "nit-alme-styles";
		linkTag.setAttribute('type', 'text/css');
		linkTag.setAttribute('rel', 'stylesheet');
        linkTag.setAttribute('async', 'true');
        
		linkTag.setAttribute('href', baseUrl + '/nextit-alme-styles.css?' + AlmeUiVersion);
        appendTheChild(linkTag);
    }


    NITLoadCss();

    (function loadBundle() {
        const scriptTag = document.createElement('script');
        scriptTag.id = "nit-bundle";
        scriptTag.setAttribute('type', 'text/javascript');
        scriptTag.setAttribute('language', 'javascript');
        scriptTag.setAttribute('async', 'true');
        scriptTag.setAttribute('defer', 'true');
        scriptTag.setAttribute('charset', 'UTF-8');

        scriptTag.setAttribute('src', baseUrl + '/nextit-bundle.js?' + AlmeUiVersion);

        const parent = document.getElementsByTagName('head')[0];
        if (parent) parent.appendChild(scriptTag);
    }());

})();



// WEBPACK FOOTER //
// ./src/nextit-loader.js